import TextDropdown from "components/inputs/text-dropdown";
import TextInput from "components/inputs/text-input";
import ModalTemplate from "components/modal/modal-template";
import Radio from "components/radio";
import Toast from "components/toast";
import Typography from "components/typography";
import React, { useEffect, useMemo, useState } from "react";
import api from "services/axiosInstance";
import { RefreshToken } from "services/refreshToken";
import { AddArtistData } from "services/user/setUser";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  close: () => void;
  confirm: (loading: boolean, success?: boolean) => void;
}
const CreateArtistModal = ({ close, confirm }: IProps) => {
  const [artistName, setArtistName] = useState("");
  const [streamingService, setStreamingService] = useState(false);
  const [spotifyUrl, setSpotifyUrl] = useState("");
  const [spotifyName, setSpotifyName] = useState("");
  const [artistEmail, setArtistEmail] = useState("");
  const disabelConfirm = useMemo(() => {
    if (artistName.length < 3) {
      return true;
    }
    if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(artistEmail)) {
      return true;
    }
    if (streamingService && spotifyName.length < 3 && spotifyUrl.length < 3) {
      return true;
    }

    return false;
  }, [artistName, artistEmail, spotifyName, streamingService, spotifyUrl]);

  const CreateArtist = async () => {
    try {
      confirm(true);

      const { data } = await api.post("/artists/create-simple", {
        name: artistName,
        email: artistEmail
      });

      await RefreshToken();
      Toast({ type: "success", message: "Artist created successfully" });
      AddArtistData(data.data);
      localStorage.setItem("accessToken", data.data.newAccessToken);
      confirm(false, true);
    } catch (error) {
      Toast({ error });
    } finally {
      confirm(false);
    }
  };

  // const ChangePlan = async () => {
  //   try {
  //     await api.post("/users/upgrade-plan", {
  //       newPlan: "label"
  //     });
  //   } catch (error) {}
  // };
  // useEffect(() => {
  //   ChangePlan();
  // }, []);
  return (
    <ModalTemplate
      header={"Add New Artist"}
      confirmText={"Create Artist"}
      close={close}
      disableConfirm={disabelConfirm}
      confirm={() => {
        CreateArtist();
      }}
    >
      <Typography mb="2.4" color={Colors.white300}>
        Let’s set up your new artist, please provide the name of an artist , or
        find them on Spotify
      </Typography>
      <TextInput
        placeholder="Enter artist name or select from plan artists"
        label="Artist Name"
        required
        value={artistName}
        onChange={(e) => setArtistName(e.target.value)}
      />
      <Gap />
      <TextInput
        placeholder="Enter artist email"
        label="Artist Email"
        required
        value={artistEmail}
        onChange={(e) => setArtistEmail(e.target.value)}
      />

      <Typography mt="2.4" weight="medium" mb="1.6">
        Does This Artist have a Spotify Account?
      </Typography>
      <StreamingServiceRadioContainer>
        <Radio
          value={streamingService}
          onClick={() => setStreamingService(true)}
        />
        <Typography color={Colors.white200} ml="0.4" mr="5">
          Yes
        </Typography>
        <Radio
          value={!streamingService}
          onClick={() => setStreamingService(false)}
        />
        <Typography color={Colors.white200} ml="0.4">
          No
        </Typography>
      </StreamingServiceRadioContainer>
      {streamingService && (
        <>
          <StreamingServiceItem>
            <TextDropdown
              label="Spotify Artist Name"
              placeholder="Enter your Artist’s  Name"
              value={spotifyName}
              required
              selectItem={(e) => setSpotifyName(e)}
              items={[]}
            />
          </StreamingServiceItem>
          <StreamingServiceItem>
            <TextInput
              label="Can’t Find Artist?"
              placeholder="Enter Spotify Artist Link"
              value={spotifyUrl}
              onChange={(e) => setSpotifyUrl(e.target.value)}
            />
          </StreamingServiceItem>
        </>
      )}
    </ModalTemplate>
  );
};

export default CreateArtistModal;

const StreamingServiceRadioContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StreamingServiceItem = styled.div`
  margin-top: 2.4rem;
`;

const Gap = styled.div`
  height: 1.4rem;
`;
